module.exports = __webpack_public_path__ + "img/fleur_lys.b550f91d.webp";